/**
 * 随心修
 */
import { FIXRECORD } from '../types';

export default {
    name: `${FIXRECORD}`,
    path: '/fixRecord',
    component: () => import(/* webpackChunkName: 'fixRecord' */ '@/views/fixRecord/'),
    redirect: { name: `${FIXRECORD}Index` },
    meta: {
        title: '随心修',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${FIXRECORD}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'fixRecord' */ '@/views/fixRecord/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${FIXRECORD}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'fixRecord' */ '@/views/fixRecord/detail/Detail.vue'),
        },
    ],
};
